import { theme } from "assets/theme";
import { PlayIcon } from "components/icons";
import { E_Route } from "utils/constants";
import { PodcastPlayIconStyle, PodcastPlayStyle } from "../styles";

export const PodcastPlayButton = () => {
  return (
    <a href={E_Route.Podcast} className={PodcastPlayStyle}>
      <PlayIcon style={PodcastPlayIconStyle} fill={theme.colors.text.dark} />
    </a>
  );
};
